@if (answers.length > 0) {
  <div class="chart-container">
    <div class="graphic">
      <ngx-charts-bar-horizontal
        class="chart d-none d-md-block mr-5"
        [scheme]="colorScheme"
        [customColors]="customColors"
        [results]="answers"
        [barPadding]="40"
        [maxYAxisTickLength]="40"
        [noBarWhenZero]="false"
        [showDataLabel]="true"
        [tooltipDisabled]="true"
        [wrapTicks]="true"
        [xAxisTickFormatting]="xAxisFormat"
        [yAxis]="true"
        [view]="view"
      >
      </ngx-charts-bar-horizontal>
      <ngx-charts-bar-horizontal
        class="chart d-block d-md-none"
        [scheme]="colorScheme"
        [customColors]="customColors"
        [results]="answers"
        [barPadding]="40"
        [maxYAxisTickLength]="40"
        [noBarWhenZero]="false"
        [xAxisTickFormatting]="xAxisFormat"
        [showDataLabel]="true"
        [view]="view"
      >
      </ngx-charts-bar-horizontal>
    </div>
    @if (answers.length > 0) {
      <div class="mt-auto d-flex w-100 justify-content-center">
        <p class="chart-text">
          {{ 'pages.QUIZ-CHARTS.RESPONSE-BREAKDOWN' | transloco }}
        </p>
      </div>
    }
  </div>
}
<div class="text-center">
  @if (statusDetail === 'error') {
    <app-no-data-container
      [firstParagraph]="'pages.QUIZ-CHARTS.ERROR-ANSWERS-GRAPHIC' | transloco"
      [isChartCard]="true"
    >
    </app-no-data-container>
  }
</div>
